import { render, staticRenderFns } from "./CourseCardSearch.vue?vue&type=template&id=a80596cc&scoped=true"
import script from "./CourseCardSearch.vue?vue&type=script&lang=js"
export * from "./CourseCardSearch.vue?vue&type=script&lang=js"
import style0 from "./CourseCardSearch.vue?vue&type=style&index=0&id=a80596cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80596cc",
  null
  
)

export default component.exports